<button [style.background-image]="'url(' + assetsUrl + 'img/botones/Boton_Asignar.png)'" class="btn btn-rounded btn-cabecera"
  matTooltip="{{'texto_491' | translate }}" type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document" style="max-width: 100% !important;">
    <!--Content-->
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <form [formGroup]="myForm">
          <div class="card-header card-header-info">
            <h5 style="margin-bottom: 0px;" class="card-title">{{ 'texto_491' | translate }}</h5>
          </div>
          <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
            data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

          <div class="row">
            <div class="col-md-6" style="margin-top: 1.2rem">
              <mat-form-field>
                <mat-label>{{ 'texto_492' | translate}}</mat-label>
                <mat-select formControlName="selectReceptor" (click)="getAvailablereceiver()">
                  <mat-option *ngIf="receptorTipoDen?.length > 0" disabled>
                    {{ 'texto_930' | translate }}
                  </mat-option>

                  <mat-option *ngFor="let item of receptorTipoDen" [value]="item.id_user">
                    {{ item.n_user }} {{ item.ape_user }}
                  </mat-option>

                  <mat-option *ngIf="receptorTipoDen?.length > 0" disabled>
                    {{ 'texto_493' | translate }}
                  </mat-option>

                  <ng-container *ngIf="receptores2Ready">
                    <mat-option *ngFor="let item2 of receptores2" [value]="item2.id_user">
                      {{ item2.n_user }} {{ item2.ape_user }}
                    </mat-option>
                  </ng-container>

                </mat-select>
                <mat-error *ngIf="selectReceptor.hasError('required')" style="font-size: 13px;">
                  {{ 'texto_879' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class='col-md-6' style="margin-top: 0.8rem">
              <div class="form-group">
                <label class="control-label">{{ 'texto_494' | translate }}</label> <br>
                <div class="table-responsive" *ngIf="receptor_select?.length > 0; else noData">
                  <table class="table">
                    <tbody>
                      <tr *ngFor="let item2 of receptor_select">
                        <td>{{item2.n_user}} {{item2.ape_user}}</td>
                        <td class="td-actions text-right" style="width: 90px;">
                          <button (click)="deletereceptor(item2.id_user)" type="button" rel="tooltip" title="Remove"
                            class="" style="background: none;color: red; border: none;">
                            <i class="material-icons">clear</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ng-template #noData>
                  <div
                    style="display:flex; justify-content:center; align-items:center; height:70px; font-size:1rem; color:gray;">
                    {{'texto_909' | translate }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="text-center mt-3">
            <button (click)="asignarReceptor()" style="color:#fff" mdbBtn rounded="true"
              class="btn-primary mt-1 waves-light" mdbWavesEffect [disabled]="myForm.get('selectReceptor').invalid">
              {{ 'texto_384' | translate}}
            </button>
          </div>
        </form>
      </div>
      <!--/.Content-->
    </div>
  </div>
</div>
